import { useState, useEffect } from "react"
import axiosWithAuth from "../../utils/axiosWithAuth"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

function StockinForm({ stockinList, setStockinList, stockoutList }) {
  const [ stockinid, setStockinid ] = useState("")  

  const fetchStockinList = async () => {
    await axiosWithAuth().get("/stock/out-of-stock")
      .then(res => {
        return setStockinList(res.data)
      })
      .catch(() => {
        return toast("Something went wrong fetching out-of-stock list")
      })
  }

  useEffect(() => {
    return fetchStockinList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ stockoutList ])

  const handleStockinChange = e => {
    return setStockinid(e.target.value)
  }
  
  const handleStockinSubmit = async e => {
    e.preventDefault()
    
    await axiosWithAuth().put(`/stock/stockin/${stockinid}`)
      .then(() => {
        return fetchStockinList()
      })
      .catch(() => {
        return toast("Something went wrong setting 'In Stock'")
      })
  }

  return (
    <>
      <form className="sm-stockout-form">
        <label className="sm-stockout-label">Set In Stock</label>
        <select className="sm-stockout-dropdown" type="dropdown" onChange={handleStockinChange}>

          <option value="">- Select an item -</option>
          {stockinList.length > 0 ?
            <option value="0-0">Reset ALL In Stock</option>
          : null}

          <option disabled>--------------- Appetizers ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Appetizer" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Deli Sub ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Deli Sub" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Hot Sub ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Hot Sub" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Salad ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Salad" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Calzone ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Calzone" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Dinner ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Dinner" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

          <option disabled>--------------- Pizza ---------------</option>
          {stockinList.length > 0 ?
            stockinList.map(item => (
              item.unit === "Pizza" ?
                <option value={item.stock_id} key={item.stock_id}>{item.name}</option>
              : null
            ))
          : null}

        </select>     
        <button className="ad-tool" onClick={handleStockinSubmit}>Submit</button>       
      </form>
    </>
  )
}

export default StockinForm
